import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'

import { IntlService } from '@progress/kendo-angular-intl'
import * as CryptoJS from 'crypto-js'
import { NgxUiLoaderService } from 'ngx-ui-loader'
import { environment } from '../../../../environments/environment'

import { NgFor, NgIf } from '@angular/common'
import { LabelDirective } from '@progress/kendo-angular-label'
import { ToastrService } from 'ngx-toastr'
import { RepServices } from '../../../@theme/services/replist.service'
import { TransactionsServices } from '../../../@theme/services/transactions.service'
import { AccountTransactionComponent } from '../../AccountForm/Tabsaccount/accounttransaction.component'
import { DropDownHoverComponent } from '../atoms/dropdownhover'
import { FieldBuilderComponent } from '../field-builder/field-builder.component'

@Component({
    selector: 'gd-step2form',
    styleUrls: ['./step2Transactions.component.css'],
    standalone: true,
    template: `
   <!-- Warning Alerts -->
        <div
       class="alert alert-dark text-center font-bold text-red-600"
  role="alert"
      *ngIf="checkreviewShowmsg"
    >
    There is an account review form that must be completed for this account.
    </div>
<div
  class="alert alert-dark text-center font-bold text-red-600"
  role="alert"
  *ngIf="showStateWarning && !missingstateerror"
>
  ⚠️ Warning: Rep is not registered to sell {{ productTypestring }} in client state of {{ stateof }}.
</div>

<div
  class="alert alert-dark text-center font-bold text-red-600"
  role="alert"
  *ngIf="showStateWarning && missingstateerror"
>
  ❌ Error: You cannot continue until a state has been added to the client.
</div>

<div
  class="alert alert-dark text-center font-bold text-red-600"
  role="alert"
  *ngIf="showDateWarning"
>
  ⚠️ Warning: Account Form Date is greater than 3 years from Date Received.
</div>

<div
  class="alert alert-dark text-center font-bold text-red-600"
  role="alert"
  *ngIf="showNetWorthWarning"
>
  ⚠️ Warning - Insufficient Net Worth.
</div>

<!-- Account Transaction -->
<div>
  <gd-accounttransaction *ngIf="showAccount"></gd-accounttransaction>
</div>

<!-- Main Content with Validation Panel -->
<div class="relative flex gap-4">
  <!-- Form Section -->
  <form
    (ngSubmit)="submitEvent.emit(this.form.value)"
    [formGroup]="form"
    class="form-horizontal flex-1"
  >
    <div *ngFor="let field of fields">
      <gd-field-builder
        [field]="field"
        [form]="form"
        [clientId]="clientId"
        [blotId]="blotId"
        *ngIf="field.label !== null"
      ></gd-field-builder>
    </div>

    <!-- Action Container -->
    <div
      class="action-container bg-light  shadow-md rounded-xl mt-4 p-4"
      *ngIf="fields?.length > 0"
    >
      <div class="action-row flex flex-wrap items-center justify-between">
        <!-- Status Dropdown -->
        <div class="action-col flex flex-col">
          <label
            [for]="statusType?.name"
            *ngIf="statusType"
            class="action-label font-semibold mb-1"
          >
            {{ statusType.label }}
          </label>
          <gd-dropdownhover
            *ngIf="statusType"
            [field]="statusType"
            [form]="form"
            [width]="'250px'"
            [height]="'36px'"
          ></gd-dropdownhover>
        </div>

        <!-- Buttons -->
        <div class="action-col right flex flex-col items-end">
          <label class="action-label mb-2" *ngIf="blotId">
            Transaction ID: {{ blotId }}
          </label>
          <div class="action-row flex gap-3">
            <button
              type="submit"
              class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
              (click)="onSubmit('Next')"
              [disabled]="isButtonDisabled() || saving || deleting"
            >
              <span *ngIf="!saving">Save</span>
              <span *ngIf="saving" class="k-i-loading k-icon animate-spin"></span>
            </button>

           <!--  <button
              *ngIf="shouldShowForceSave()"
              type="button"
              class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-warning"
              (click)="onForceSave()"
              [disabled]="saving || deleting"
              title="Save without validation - use when required fields are missing"
            >
              <span *ngIf="!saving"></span>
              <span *ngIf="saving" class="k-i-loading k-icon animate-spin"></span>
            </button>
 -->
            <button
              *ngIf="roleSelect && blotId"
              class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              (click)="onSubmit('Removious')"
              [disabled]="isDeleteDisabled()"
            >
              <span *ngIf="!deleting">Delete</span>
              <span *ngIf="deleting" class="k-i-loading k-icon animate-spin"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!-- Floating Validation Summary Panel -->
  <div
    *ngIf="showValidationPanel()"
    class="validation-panel sticky top-4 w-72 h-fit bg-white dark:bg-gray-900 border-2 border-red-500 rounded-lg shadow-lg p-4"
  >
    <div class="flex items-center gap-2 mb-3 pb-2 border-b border-red-200 dark:border-red-800">
      <span class="text-red-600 text-xl">⚠️</span>
      <h3 class="font-bold text-red-600 dark:text-red-400">Required Fields Missing</h3>
    </div>
    
    <div class="space-y-2 max-h-96 overflow-y-auto">
      <div
        *ngFor="let error of getInvalidFields()"
        class="flex items-start gap-2 p-2 bg-red-50 dark:bg-red-900/20 rounded hover:bg-red-100 dark:hover:bg-red-900/30 transition-colors cursor-pointer"
        (click)="scrollToField(error.name)"
      >
        <span class="text-red-500 mt-0.5">•</span>
        <div class="flex-1">
          <div class="font-medium text-sm text-gray-900 dark:text-gray-100">
            {{ error.label }}
          </div>
          <div class="text-xs text-red-600 dark:text-red-400">
            {{ error.message }}
          </div>
        </div>
      </div>
    </div>
    
    <div class="mt-3 pt-3 border-t border-red-200 dark:border-red-800 text-xs text-gray-600 dark:text-gray-400">
      {{ getInvalidFields().length }} field(s) need attention
    </div>
  </div>
</div>

  `,
    imports: [
        NgIf,
        AccountTransactionComponent,
        FormsModule,
        ReactiveFormsModule,
        NgFor,
        FieldBuilderComponent,
        LabelDirective,
        DropDownHoverComponent,
    ]
})
export class Step2TransactionFormComponent implements OnInit, OnChanges {
  @Output() submitEvent = new EventEmitter()
  public opened = false
  public saving = false
  public deleting = false
  showAccount = false
  mybuttontype: string
  unsubcribe: any
  private storageValueReturn = localStorage.getItem('rvarietylist')
  @Input() loading: boolean
  @Input() loadingDelete: boolean
  @Input() statusTypeId: any
  @Input() RepSelected: number
  @Input() ClientSelected: number
  @Input() productTypeSelected: number
  @Input() transactionTypeSelected: number
  @Input() SourceofFundsSelected: number
  @Input() RepCodeSelected: number
  @Input() repNamestring: string
  @Input() repCodestring: string
  @Input() Clientstring: string
  @Input() productTypestring: string
  @Input() stateof: string
  @Input() transactionTypestring: string
  @Input() sourceoffundsstring: string
  @Input() clientthirdlisting: Array<any>
  @Input() taxen: string
  public clientlist: any[] = []
  public fields: any[] = []
  public value: Date = new Date()
  @Input() LiquidNWTo: string
  @Input() LiquidNWFrom: string
  @Input() NetWorthTo: string
  @Input() NetWorthFrom: string
  @Input() AnnualIncTo: string
  @Input() AnnualIncFrom: string
  private index = 0
  private getname: string
  @Input() InvestmentProfileId: number
  @Input() InvestmentTimeHorizonId: number
  @Input() LiquidityNeedsId: number
  @Input() InvObjectiveId: number

  @Input() InvestDescription: string
  @Input() InvestmentTimeHorizonDescription: string
  @Input() ProfileDescription: string
  @Input() LiquidDescription: string

  @Input() clientId: number
  @Input() lblRep: string
  @Input() dob: Date
  @Input() Email: string
  public selectedValue: any
  public btnenabled: boolean
  public blotId: number
  public form: UntypedFormGroup
  public showStateWarning: boolean
  public checkreviewShowmsg: boolean
  public missingstateerror: boolean
  public showDateWarning: boolean
  public showNetWorthWarning: boolean
  public statusType: any
  private isStatusTypeEleven: number
  public roleSelect: boolean
  public canAlwaysDelete = false
  private isAdminRole = false
  groupValidators = [this.ValidateDates(), this.ValidateNetWorth()]

  private approvedAlertWasOn = false

  private lockStatusIfApproved(): void {
    if (this.isStatusTypeEleven === 11) {
      const ctrl = this.form.get('StatusTypeID')
      if (ctrl) {
        ctrl.disable({ emitEvent: false })
      }
      // Controls are built straight from the loaded field values, so this is the
      // alert as it came off the transaction - before the user touches anything.
      this.approvedAlertWasOn = this.isFlagTrue(this.form.get('AlertRep')?.value)
    }
  }


  private isFlagTrue(value: any): boolean {
    return value === true || String(value).toLowerCase() === 'true'
  }

  
  private canClearApprovedAlert(): boolean {
    if (!this.approvedAlertWasOn) {
      return false
    }
    const ctrl = this.form.get('AlertRep')
    // Reps have this control disabled and may not clear alerts.
    if (!ctrl || ctrl.disabled) {
      return false
    }
    // Only unlock once the user has actually turned the alert off.
    return ctrl.dirty && !this.isFlagTrue(ctrl.value)
  }

  constructor(
    private toastrService: ToastrService,
    private transservice: TransactionsServices,
    private route: ActivatedRoute,
    private repService: RepServices,
    private Intl: IntlService,
    private cdr: ChangeDetectorRef,
    private ngxService: NgxUiLoaderService,
  ) {
    this.form = new UntypedFormGroup({
      fields: new UntypedFormControl(this.fields),
    })
    /*     this.loading = false;
    this.loadingDelete = false; */
    if (this.storageValueReturn !== null) {
      const paramT = CryptoJS.AES.decrypt(
        this.storageValueReturn.trim(),
        `${environment.securepw.trim()}`,
      ).toString(CryptoJS.enc.Utf8)

      const checkParamT = decodeURI(paramT)

      if (checkParamT.toLowerCase() === 'rep'.toLowerCase() || 
          checkParamT.toLowerCase() === 'BRANCH ACCESS NON MANAGER'.toLowerCase()) {
        this.roleSelect = false
      } else {
        this.roleSelect = true
      }

      const roleLower = checkParamT.toLowerCase()
      this.canAlwaysDelete = roleLower === 'admin' || roleLower === 'trading principal'
      this.isAdminRole = roleLower === 'admin'
    }
    if (this.route.snapshot.queryParams['Cld']) {
      this.showAccount = true
    }
  }
  isButtonDisabled(): boolean {
    this.route.queryParams.subscribe((params) => {
      const getstatustypeid = params['accountstatus']
      this.isStatusTypeEleven = Number(getstatustypeid)
    })
    if (this.isStatusTypeEleven === 11) {
      // Status stays locked for everyone, admins included - an approved
      // transaction cannot be moved off Approved from this screen.
      this.form.get('StatusTypeID')?.disable({ emitEvent: false })
      // Approved is otherwise read-only for every non-admin role, with one
      // exception: clearing an alert that was already set. Admins may edit and
      // save any field, subject only to the usual validity rules.
      if (!this.isAdminRole) {
        return !this.canClearApprovedAlert()
      }
    }
    return (
      !this.form.valid ||
      this.form.pristine
    )
  }
  /* Delete keeps the original rules - the alert-clearing exception above unlocks
     Save only, and must not make an approved transaction deletable. */
  isDeleteDisabled(): boolean {
    if (this.canAlwaysDelete) {
      return this.deleting || this.saving
    }
    if (this.isStatusTypeEleven === 11) {
      return true
    }
    return this.isButtonDisabled() || this.deleting || this.saving
  }
  ngOnInit(): void {
    if (this.route.snapshot.queryParams['Cld']) {
      this.showAccount = true
    }
    // Initialize status type from query params
    if (this.route.snapshot.queryParams['accountstatus']) {
      this.isStatusTypeEleven = Number(this.route.snapshot.queryParams['accountstatus'])
    }
    if (this.route.snapshot.queryParams['Rview']) {
      // QueryString Review heres
      this.route.queryParams.subscribe((params) => {
        const getblotterClientId = CryptoJS.AES.decrypt(
          params['Rview'],
          `${environment.securepw}`,
        ).toString(CryptoJS.enc.Utf8)
        this.blotId = Number(getblotterClientId)
        const getClientId = CryptoJS.AES.decrypt(
          params['clientId'],
          `${environment.securepw}`,
        ).toString(CryptoJS.enc.Utf8)
        this.clientId = Number(getClientId)
        this.RepSelected = CryptoJS.AES.decrypt(
          params['rId'],
          `${environment.securepw}`,
        ).toString(CryptoJS.enc.Utf8)
        this.clientId = Number(getClientId)
        // Also check for status in params
        if (params['accountstatus']) {
          this.isStatusTypeEleven = Number(params['accountstatus'])
        }
      })
    }
    localStorage.setItem('UnsavedAlertText', '')
    this.missingstateerror = false
    if (this.clientId != null && this.RepSelected != null) {
      this.repService
        .isValidState(this.RepSelected, this.clientId)
        .subscribe((res) => {
          this.showStateWarning = !res
          if (res === undefined) {
            this.missingstateerror = true
          }
        })
    }

    for (const val of this.clientthirdlisting.filter(
      (c) => c.clientId === this.clientId,
    )) {
      this.clientlist.push({
        firstName: val.firstName,
        clientId: val.clientId,
        EquitiesExp: val.equitiesExp,
        OptionsExp: val.optionsExp,
        FixedIncExp: val.fixedIncExp,
        MutFundsExp: val.mutFundsExp,
        Uitexp: val.uitexp,
        Etfexp: val.etfexp,
        RealEstateExp: val.realEstateExp,
        InsExp: val.insExp,
        Vaexp: val.vaexp,
        FixedAnnExp: val.fixedAnnExp,
        PrecMetExp: val.precMetExp,
        CommExp: val.commExp,
        OtherExpDesc: val.otherExpDesc,
        OtherExp: val.otherExp,
        address1addr: val.address1,
        address2addr: val.address2,
        cityaddr: val.city,
        stateaddr: val.state,
        zipcodeaddr: val.zipCode,
      })
    }
    const paramsVal = {
      blotterId: this.blotId,
      productTypeId: this.productTypeSelected,
      sourceofFundsId: this.SourceofFundsSelected,
      transactionTypeId: this.transactionTypeSelected,
      repselect: this.RepSelected,
      clientselect: this.clientId,
      repCodeSelected: this.RepCodeSelected,
      repNamestring: this.repNamestring,
      repCodestring: this.repCodestring,
      Clientstring: this.Clientstring,
      productTypestring: this.productTypestring,
      transactionTypestring: this.transactionTypestring,
      sourceoffundsstring: this.sourceoffundsstring,
      accountname: this.clientlist,
      taxen: this.taxen,
      dob: this.dob,
      investDescription: this.InvestDescription,
      investmentTimeHorizonDescription: this.InvestmentTimeHorizonDescription,
      profileDescription: this.ProfileDescription,
      liquidDescription: this.LiquidDescription,
      liquidNWFrom: this.LiquidNWFrom,
      liquidNWTo: this.LiquidNWTo,
      annualIncFrom: this.AnnualIncFrom,
      annualIncTo: this.AnnualIncTo,
      netWorthFrom: this.NetWorthFrom,
      netWorthTo: this.NetWorthTo,
      Email: this.Email,
      statusTypeId: this.statusTypeId,
      ClientId: this.clientId,
    }
    if ('R' in this.route.snapshot.queryParams) {
      this.transservice
        .GetTransactionformlist(paramsVal)
        .subscribe(async (response: any[]) => {
          this.fields = response
          for (const o of this.fields) {
            if (o.type === 'datepicker') {
              o.value = o.value ? new Date(o.value) : null
            }
          }
          this.form = new UntypedFormGroup({
            fields: new UntypedFormControl(this.fields),
          })
          const fieldsCtrls = {}
          for (const f of this.fields) {
            if (f.required === true) {
              fieldsCtrls[f.name] = new UntypedFormControl(
                f.value ?? '',
                Validators.required,
              )
            } else {
              fieldsCtrls[f.name] = new UntypedFormControl(f.value)
            }
          }
          this.form = new UntypedFormGroup(fieldsCtrls)
          this.form.setValidators(this.groupValidators)
          this.lockStatusIfApproved()
          //  this.cdr.markForCheck();
          this.statusType = this.fields.find((f) => f.name === 'StatusTypeID')
        })
    }
    if (
      this.route.snapshot.queryParams.hasOwnProperty['RviewAccount'] !== null ||
      (this.route.snapshot.queryParams.hasOwnProperty['Rview'] !== null &&
        !sessionStorage.getItem('changeoftype'))
    ) {
      this.ngxService.startLoader('loader-03')
      if (this.blotId !== undefined) {
        this.ngxService.startLoader('loader-03')
        this.transservice
          .GetTransactionEditListing(paramsVal)
          .subscribe((response: any[]) => {
            this.fields = response
            this.ngxService.stopLoader('loader-03')
            for (const o of this.fields) {
              if (o.type === 'datepicker') {
                o.value = o.value ? new Date(o.value) : null
              }
            }
            this.form = new UntypedFormGroup({
              fields: new UntypedFormControl(this.fields),
            })
            const fieldsCtrls = {}
            for (const f of this.fields) {
              if (f.required === true) {
                fieldsCtrls[f.name] = new UntypedFormControl(
                  f.value ?? '',
                  Validators.required,
                )
              } else {
                if (
                  !this.route.snapshot.queryParams.hasOwnProperty[
                    'RviewAccount'
                  ]
                ) {
                  fieldsCtrls[f.name] = new UntypedFormControl(f.value)
                }
              }
            }
              this.statusType = this.fields.find((f) => f.name === 'StatusTypeID')
            this.form = new UntypedFormGroup(fieldsCtrls)
            this.form.setValidators(this.groupValidators)
            this.lockStatusIfApproved()
            this.ngxService.stopLoader('loader-03')
          
            this.cdr.markForCheck()
          })
      }
    }
    if (this.clientlist !== undefined) {
      if (
        this.route.snapshot.queryParams.hasOwnProperty['RviewAccount'] !==
          null ||
        (!this.route.snapshot.queryParams.hasOwnProperty['Rview'] !== null &&
          !sessionStorage.getItem('changeoftype'))
      ) {
        if (this.blotId !== undefined) {
          this.transservice
            .GetTransactionformlist(paramsVal)
            .subscribe(async (response: any[]) => {
              this.fields = Array.isArray(response) ? response : []

              for (const o of this.fields) {
                if (o.type === 'datepicker') {
                  o.value = o.value ? new Date(o.value) : null
                }
              }

              this.form = new UntypedFormGroup({
                fields: new UntypedFormControl(this.fields),
              })

              const fieldsCtrls = {}
              for (const f of this.fields) {
                if (f.name) {
                  // Validate 'name' existence
                  fieldsCtrls[f.name] = new UntypedFormControl(
                    f.value ?? '',
                    f.required ? Validators.required : null,
                  )
                }
              }

              this.form = new UntypedFormGroup(fieldsCtrls)
              this.form.setValidators(this.groupValidators)
              this.lockStatusIfApproved()
            })
          this.ngxService.stopLoader('loader-03')
          this.cdr.markForCheck()
        }
      }
    }
    this.cdr.markForCheck()
    if (sessionStorage.getItem('types')) {
      this.RevisedTransactionchange(paramsVal)
    }
    this.lockStatusIfApproved()
    this.ngxService.stopLoader('loader-03')
  }

  onSubmit(buttonType: string): void {
    sessionStorage.setItem('version', buttonType)
    if (buttonType === 'Removious') {
      this.deleting = true
    } else {
      this.saving = true
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Reset the button spinners once the parent finishes the operation
    // (on error the parent sets loading/loadingDelete back to false).
    if (changes['loading'] && this.loading === false) {
      this.saving = false
      this.deleting = false
    }
    if (changes['loadingDelete'] && this.loadingDelete === false) {
      this.deleting = false
    }
  }

  shouldShowForceSave(): boolean {
    // Check the actual StatusTypeID form control value
    const statusControl = this.form.get('StatusTypeID')
    const currentStatus = statusControl ? Number(statusControl.value) : this.isStatusTypeEleven
    
    // Never show if user is a Rep
    if (this.roleSelect === false) {
      return false
    }
    
    // Never show if status is 1 (Submitted for Review)
    if (currentStatus === 1 || this.isStatusTypeEleven === 1 || Number(this.isStatusTypeEleven) === 1) {
      return false
    }
    
    // Only show if form is invalid
    return !this.form.valid
  }

  onForceSave(): void {
    // Bypass validation and force save
    this.saving = true
    sessionStorage.setItem('version', 'Next')
    this.submitEvent.emit(this.form.value)
  }
  RevisedTransactionchange(paramsVal) {
    if (sessionStorage.getItem('changeoftype') === 'true') {
      this.transservice
        .ChangeTransactionTypesNewTypes(paramsVal)
        .subscribe((response: any[]) => {
          this.fields = response
          for (const o of this.fields) {
            if (o.type === 'datepicker') {
              o.value = o.value ? new Date(o.value) : null
            }
          }
          this.form = new UntypedFormGroup({
            fields: new UntypedFormControl(this.fields),
          })
          const fieldsCtrls = {}
          for (const f of this.fields) {
            let control

            if (f.required === true) {
              control = new UntypedFormControl(
                f.value ?? '',
                Validators.required,
              )
            } else {
              control = new UntypedFormControl(f.value ?? '')
            }

            if (f.disabled) {
              this.btnenabled = true
              control.disable()
            }
          }
          this.form = new UntypedFormGroup(fieldsCtrls)
          this.form.setValidators(this.groupValidators)
          this.lockStatusIfApproved()
          this.ngxService.stopLoader('loader-03')
        })
      this.ngxService.startBackgroundLoader('do-background-things')
    }
    this.ValidateDates()
  }

  ValidateNetWorth(): ValidatorFn {
  return (group: UntypedFormGroup): ValidationErrors | null => {
    const liquidNet = group.get('LiquidNetWorth');
    const amount = group.get('Amount');
    if (liquidNet && amount) {
      if (liquidNet.value && amount.value && (amount.value / liquidNet.value > 0.1)) {
        this.showNetWorthWarning = true;
        return { netWorthInvalid: true };
      }
    }
    this.showNetWorthWarning = false;
    return null;
  }
}

 ValidateDates(): ValidatorFn {
  return (group: UntypedFormGroup): ValidationErrors | null => {
    const dateRecievedGroup = group.get('DateReceived');
    const dateOfNewAccGroup = group.get('DateOfNewAccountForm');
    if (dateRecievedGroup && dateOfNewAccGroup) {
      const dateRecieved: Date = dateRecievedGroup.value;
      const dateOfNewAcc: Date = dateOfNewAccGroup.value;

      // Defensive: Make sure they're valid dates
      if (!dateOfNewAcc || dateOfNewAcc.toString() === '') {
        this.showDateWarning = false;
        return null;
      }
      if (!dateRecieved || dateRecieved.toString() === '') {
        this.showDateWarning = false;
        return null;
      }

      const dateDiff = dateOfNewAcc.getFullYear() - dateRecieved.getFullYear();
      if (dateDiff >= 3) {
        this.showDateWarning = true;
        return { dateRangeInvalid: true };
      } else {
        this.showDateWarning = false;
        return null;
      }
    }
    this.showDateWarning = false;
    return null;
  }
}

  /**
   * Check if validation panel should be shown
   * Show immediately on load if form has errors
   */
  showValidationPanel(): boolean {
    return !this.form.valid && this.fields && this.fields.length > 0;
  }

  /**
   * Get all invalid fields with their labels and error messages
   */
  getInvalidFields(): Array<{ name: string; label: string; message: string }> {
    const invalid: Array<{ name: string; label: string; message: string }> = [];
    const controls = this.form.controls;
    
    for (const name in controls) {
      if (controls[name].invalid) {
        // Find the field definition to get the label
        const field = this.fields.find(f => f.name === name);
        const label = field?.label || name;
        
        // Determine error message
        let message = 'This field is required';
        const errors = controls[name].errors;
        
        if (errors) {
          if (errors['required']) {
            message = 'This field is required';
          } else if (errors['email']) {
            message = 'Invalid email format';
          } else if (errors['minlength']) {
            message = `Minimum length: ${errors['minlength'].requiredLength}`;
          } else if (errors['maxlength']) {
            message = `Maximum length: ${errors['maxlength'].requiredLength}`;
          } else if (errors['pattern']) {
            message = 'Invalid format';
          } else if (errors['min']) {
            message = `Minimum value: ${errors['min'].min}`;
          } else if (errors['max']) {
            message = `Maximum value: ${errors['max'].max}`;
          }
        }
        
        invalid.push({ name, label, message });
      }
    }
    
    return invalid;
  }

  /**
   * Scroll to a specific field when clicked in validation panel
   */
  scrollToField(fieldName: string): void {
    // Try multiple selectors to find the field element
    const selectors = [
      `[formcontrolname="${fieldName}"]`,
      `[name="${fieldName}"]`,
      `#${fieldName}`
    ];
    
    let element: HTMLElement | null = null;
    
    for (const selector of selectors) {
      element = document.querySelector(selector) as HTMLElement;
      if (element) break;
    }
    
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Focus the element after scrolling
      setTimeout(() => {
        element?.focus();
        // Mark the field as touched to show validation
        if (this.form.controls[fieldName]) {
          this.form.controls[fieldName].markAsTouched();
        }
      }, 300);
    }
  }

  // OnEdit use Another Method  //
  public findInvalidControls() {
    const invalid = []
    const controls = this.form.controls
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name)
        this.getname = name
        this.showToast(0)
      }
    }
    return invalid
  }

  showToast(duration) {
    this.toastrService.show(this.getname, `You are missing a value :`)
  }

  ngDestroy() {
    this.unsubcribe()
    this.unsub()
  }
  public close(status: string): void {
 //   console.log(`Dialog result: ${status}`)
    this.opened = false
  }

  public open(): void {
    this.opened = true
  }
  RemoveBlotId() {
    this.onSubmit('Removious')
  }
  unsub() {
    this.unsubcribe = this.form.valueChanges.subscribe((update) => {
      this.fields = update.fields
    })
  }
}
